import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';

export interface ObvTileConfigState {
    symbol?: string;
    bucketSize: number;
    showDataFor?: ShowDataFor;
}

export const initialObvTileConfigState: ObvTileConfigState = {
    bucketSize: 1,
    showDataFor: ShowDataFor.AllDay,
};
